export const MESSAGE_NAMESPACE = 'urn:x-cast:com.bitmovin.analytics.cast';
export const ANALYTICS_BACKEND_BASE_URL = 'https://analytics-ingress-global.bitmovin.com';

export const ANALYTICS_LICENSECALL_TIMEOUT = 1000 * 60;
export const ANALYTICS_VIDEOSTART_TIMEOUT = 1000 * 60; // in milliseconds

